export default {
  "content": "<g clip-path=\"url(#a)\"><path fill=\"#3F4450\" fill-rule=\"evenodd\" d=\"M6.886.667h6.227c.12 0 .22.1.22.22v14.226c0 .12-.1.22-.22.22h-.927c-.12 0-.22-.1-.22-.22V6.867a.2.2 0 00-.2-.2H10.18a.427.427 0 01-.38-.227L6.7.993a.216.216 0 01.186-.326zm-.18 2.226l2.6 4.58a.44.44 0 00.387.227h1.2c.127 0 .227.1.227.22v.527c0 .12-.1.22-.227.22H2.94c-.18 0-.287-.2-.18-.34l1.693-2.214a.2.2 0 00.013-.233L2.7 2.993a.214.214 0 01.186-.326H6.32c.16 0 .306.086.386.226z\" clip-rule=\"evenodd\"/></g><defs><clipPath id=\"a\"><path fill=\"#fff\" d=\"M0 0h16v16H0z\"/></clipPath></defs>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "16",
    "height": "16",
    "fill": "none"
  }
};